import React, { useState, useEffect } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { useVsiAppContext } from "../stores/VsiApp";
import styles from "../utils/themeStyles";
import { genericColors } from "../utils/chartUtils";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

require("highcharts/indicators/indicators")(Highcharts);
require("highcharts/indicators/pivot-points")(Highcharts);
require("highcharts/indicators/macd")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/map")(Highcharts);


function PieChart({ series, data, includeLegend, title = "", height, disableLabels, legend, dataLabels, tooltip }) {
    const { theme, isTabletScreen } = useVsiAppContext();
    const basicTextStyle = {
        color: styles[theme].textColor,
        fontFamily: styles[theme].fontFamily,
    };

    const updateSeries = (series, data) => {
        if (series) return series;
        else if (data)
            return [
                {
                    data,
                },
            ];
        return [];
    };

    const [chartOptions, setChartOptions] = useState(
       {
         mapNavigation: {
           enabled: false,
         },
           colors: genericColors,
            chart: {
                backgroundColor: 'transparent' || styles[theme].cardBgColor,
                color: styles[theme].textColor,
                type: 'pie',
                height: height || 500,
            },
           credits: {
               enabled: false,
           },
            title: {
                text: title,
                style: {
                  ...basicTextStyle,
                  fontSize: '1rem'
                },
            },
            tooltip: {
                pointFormat: '<b>{point.percentage:.1f}%</b> <br/> <b>{point.y}</b>',
                backgroundColor: styles[theme].altBgColor,
                style: basicTextStyle,
                ...(tooltip || {}),
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: disableLabels ? !disableLabels : true,
                        format: '{point.percentage:.1f} %',
                      color: basicTextStyle.color,
                        style: basicTextStyle,
                      ...(dataLabels || {})
                    },
                    showInLegend: true
                }
            },
            legend: {
                itemStyle: basicTextStyle,
                align: "center",
                enabled: !!includeLegend,
                ...(legend || {}),
            },
            series: updateSeries(series, data),
        });

    useEffect(() => {
        setChartOptions(() => {
            return {
                ...chartOptions,
                chart: {
                    ...chartOptions.chart,
                    backgroundColor: 'transparent' || styles[theme].cardBgColor,
                    color: styles[theme].textColor,
                    height: height || 500,
                },
                tooltip: {
                  ...chartOptions.tooltip,
                    backgroundColor: styles[theme].altBgColor,
                    style: basicTextStyle,
                    ...(tooltip || {}),
                },
                title: {
                    ...chartOptions.title,
                  text: title,
                  style:  {
                      ...chartOptions.title.style,
                    ...basicTextStyle,
                  },
                },
                legend: {
                    ...chartOptions.legend,
                    itemStyle: basicTextStyle,
                    align: "center",
                    ...(legend || {}),
                },
                plotOptions: {
                  ...chartOptions.plotOptions,
                  pie: {
                    ...chartOptions.plotOptions.pie,
                    dataLabels: {
                      ...chartOptions.plotOptions.pie,
                      color: basicTextStyle.color,
                      style: basicTextStyle,
                      ...(dataLabels || {})
                    },
                  }
                },
                series: updateSeries(series, data)
            }
        })
    }, [theme, isTabletScreen, series, legend, title, height, tooltip]);

    return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
}

PieChart.displayName = "PieChart"

export default withErrorBoundary(PieChart, GeneralErrorBoundary);
